import React, { useState } from "react";
import { Badge, Button, Modal } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Constants from "../Variables/Constants";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCartItems } from "../../redux/cartSlice";

const Product = ({ product, flag, setFlag, categoryId, collectionId }) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const fetchCart = async () => {
    try {
      const res = await axios.get(Constants.getUrls.getCart, {
        headers: { Authorization: token },
      });
      if (res.data.status === "success") {
        const data = res.data.data.docs;
        const arr = [];
        if (data && Array.isArray(data) && data.length > 0) {
          data.map((item) => {
            arr.push({
              _id: item._id,
              product_id: item.product_id._id,
              images: item.product_id.images,
              name: item.product_id.name,
              price: item.product_id.price,
              quantity: item.quantity,
            });
          });
          dispatch(setCartItems(arr));
          localStorage.removeItem("cart");
        } else {
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(res.data.message);
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleAddToCart = (product) => {
    try {
      if (!token) {
        const localCart = localStorage.getItem("cart");
        const obj = { _id: product._id, quantity: 1 };
        if (localCart) {
          const cartLocalData = JSON.parse(localCart);
          if (cartLocalData && Array.isArray(cartLocalData)) {
            const existingProduct = cartLocalData.filter(
              (io) => io._id === obj._id
            );
            if (existingProduct.length > 0) {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.error("Product Already In Cart!");
              return;
            }
            const data = [...JSON.parse(localCart), obj];
            localStorage.setItem("cart", JSON.stringify(data));
            dispatch(setCartItems(data));
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Product Added To Cart!");
            return;
          } else {
            const data = [obj];
            localStorage.setItem("cart", JSON.stringify(data));
            dispatch(setCartItems(data));
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Product Added To Cart!");
            return;
          }
        } else {
          const data = [obj];
          localStorage.setItem("cart", JSON.stringify(data));
          dispatch(setCartItems(data));
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.success("Product Added To Cart!");
          return;
        }
      } else {
        axios
          .post(
            Constants.postUrls.AddToCart,
            {
              product_id: product._id,
              quantity: 1,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then((resp) => {
            if (resp.data.status === "success") {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.success("Product added to cart successfully!", {
                style: { backgroundColor: "green", color: "white" },
              });
              fetchCart();
            }
          })
          .catch((error) => {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(error.message);
          });
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleHeartToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!token) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Please Login First!");
      navigate("/login", {
        state: { locationPath: window.location.href, data: product },
      });
      return;
    }
    try {
      axios
        .put(
          `${Constants.getUrls.toggleProduct}/${product._id}`,
          {
            is_favourite: product.is_favourite === "yes" ? "no" : "yes",
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          }
        )
        .then((resp) => {
          if (resp.status === 200) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success(
              product.is_favourite === "yes"
                ? "Product removed from favourites!"
                : "Product added to favourites!"
            );
          } else {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(resp.data.message);
          }
          setFlag(!flag);
        })
        .catch((error) => {
          setFlag(!flag);
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Something went wrong", error.message);
        });
    } catch (error) {
      setFlag(!flag);
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };
  return (
    <>
      <div className="product_card">
        <NavLink
   to={
  product?.category?.slug === "tallistefillin-bags" ||
  product?.category?.slug === "passover"
    ? `/customize?productId=${product?._id}&isEdit=true&customizeImageId=${product?.customize_image_id?._id}&categoryId=${categoryId}&collectionId=${collectionId}`
    : `/category/collection/product-detail?catid=${categoryId}&collectionId=${collectionId}&productId=${product?._id}`
}

          key={product?._id}
          state={{ ...product }}
        >
          <div className="product_card_img">
            <img loading="lazy"  
            
            // onClick={(e) => {
            //     e.preventDefault();
            //     e.stopPropagation();
            //     handleShow();
            //   }}
              src={(product?.images && Array.isArray(product?.images) && product?.images?.length > 0) ? Constants?.imgDomain + product?.images[0] : "/prod.png"}
              // src="/prod.png"
              alt="" />
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleAddToCart(product);
              }}
            >
              Add to cart
            </Button>
          </div>
        </NavLink>

        <div className="product_badges">
          <div className="z-2" onClick={(e) => e.stopPropagation()}>
            {/* <Badge
              onClick={(e) => e.stopPropagation()}
              bg
              className="new_badge"
            >
              New
            </Badge> */}
            {/* 
                        <Badge bg className="prcnt_badge">
                            -70%
                        </Badge> */}
          </div>
          <div>
            <div
              className="badges_icons"
              onClick={(e) => {
                handleHeartToggle(e);
              }}
            >
              {product?.is_favourite === "no" || !product?.is_favourite ? (
                <i className="mt-1 bi bi-heart" style={{ color: "grey" }}></i>
              ) : (
                <i
                  className="mt-1 bi bi-heart-fill"
                  style={{ color: "blue" }}
                ></i>
              )}
            </div>
            {/* <div
              className="badges_icons"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleShow();
              }}
            >
              <i className="bi bi-eye" style={{ color: "grey" }}></i>
            </div> */}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="product_name">{product?.name}</div>
          <div className="mt-3">
            <span className="price">${product?.price}</span>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Product View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img loading="lazy" 
            src={(product?.images && Array.isArray(product?.images) && product?.images?.length > 0) ? Constants?.imgDomain + product?.images[0] : "/prod.png"}
            style={{ width: "100%" }}
            alt=""
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Product;
